<script setup lang="ts">
interface Props {
  color?: string
}
withDefaults(defineProps<Props>(), {
  color: '#3EB6A6',
})

// 旧: nuxt-aos の data-aos="fade-right/left"。Nuxt 4 で nuxt-aos は撤廃したため
// （#469）、@vueuse/nuxt の useIntersectionObserver + CSS トランジションで同等の
// スクロールインを再現する。SSR でも追加のクライアント専用プラグインが不要。
const root = ref<HTMLElement | null>(null)
const visible = ref(false)
const { stop } = useIntersectionObserver(
  root,
  ([entry]) => {
    if (entry?.isIntersecting) {
      visible.value = true
      stop()
    }
  },
  { threshold: 0.1 },
)
</script>

<template>
  <div
    ref="root"
    class="hero-title-bar"
  >
    <div
      class="hero-title-main aos-item aos-fade-right"
      :class="{ 'aos-in': visible }"
    >
      <slot name="main" />
    </div>
    <div
      class="hero-title-sub aos-item aos-fade-left"
      :class="{ 'aos-in': visible }"
    >
      <slot name="sub" />
    </div>
  </div>
</template>

<style scoped>
.hero-title-bar {
    position: relative;
}

/* AOS 相当のスクロールイン（fade-right = 左からスライドイン, fade-left = 右から） */
.aos-item {
    opacity: 0;
    transition: opacity 0.6s ease, transform 0.6s ease;
    transition-delay: 200ms;
    will-change: opacity, transform;
}

.aos-fade-right {
    transform: translate3d(-40px, 0, 0);
}

.aos-fade-left {
    transform: translate3d(40px, 0, 0);
}

.aos-item.aos-in {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

@media (prefers-reduced-motion: reduce) {
    .aos-item {
        opacity: 1;
        transform: none;
        transition: none;
    }
}

@media (max-width: 600px) {
    .hero-title-main {
        /* color: #909090; */
        color: v-bind(color);

        text-align: right;
        font-weight: bold;
        /* font-size: 7.0em; */
        font-size: 3rem;
        padding: 0 0.5em 0.1em 0.2em;
    }

    .hero-title-sub {
        /* position: absolute; */
        /* color: black; */
        color: var(--landing-color-navy);

        font-size: 1em;
        font-weight: bold;
        /* text-align: left; */
        /* top: 66px; */
        /* padding: 0 0 0 2em; */
        margin-bottom: 2rem;
    }
}

@media (min-width: 600.02px) {
    .hero-title-main {
        /* color: #909090; */
        color: v-bind(color);

        text-align: right;
        font-weight: bold;
        font-size: 7.0em;
        padding: 0 0.5em 0.1em 0.2em;
    }

    .hero-title-sub {
        position: absolute;
        /* color: black; */
        color: var(--landing-color-navy);

        font-size: 1.1em;
        font-weight: bold;
        text-align: left;
        top: 66px;
        padding: 0 0 2em;
    }
}
</style>
